import { motion, useReducedMotion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { FondoVideoAmbient } from "../../shared";

export default function Portada({ datos }) {
  const { protagonista, evento, fotos } = datos;
  const reduce = useReducedMotion();
  const entrar = (delay) => ({
    initial: { opacity: 0, y: reduce ? 0 : 26 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <header className="xv-portada" data-testid="xv-portada">
      <motion.p className="xv-portada-frase" {...entrar(0.1)}>
        {protagonista.fraseIntroductoria}
      </motion.p>
      <motion.div className="xv-portada-marco" {...entrar(0.25)}>
        <div className="xv-portada-media">
          {datos.portadaVideo?.urlYoutube ? (
            <FondoVideoAmbient
              urlYoutube={datos.portadaVideo.urlYoutube}
              poster={datos.portadaVideo.poster || fotos.portada}
            />
          ) : (
            <img
              className="xv-portada-foto"
              src={fotos.portada}
              alt={`Fotografía de ${protagonista.nombre}`}
            />
          )}
        </div>
        <Sparkles className="xv-portada-destello" aria-hidden="true" />
      </motion.div>
      <div className="xv-portada-texto">
        <motion.h1 className="xv-portada-nombre" data-testid="xv-nombre" {...entrar(0.45)}>
          {protagonista.nombre}
        </motion.h1>
        <motion.p className="xv-portada-fecha" data-testid="xv-fecha" {...entrar(0.6)}>
          {evento.fechaLegible} · {evento.ciudad}
        </motion.p>
        <motion.p className="xv-portada-mensaje" {...entrar(0.72)}>
          {protagonista.mensajePortada}
        </motion.p>
        {protagonista.textoBotonEntrada && (
          <motion.a
            href="#xv-contenido"
            className="xv-boton"
            data-testid="xv-boton-bajar"
            {...entrar(0.85)}
          >
            {protagonista.textoBotonEntrada}
          </motion.a>
        )}
      </div>
    </header>
  );
}
